import { useMutation } from 'react-query';
import { network } from 'services/network';

const mutationFn = (params: QueryParams) => {
    return network.post('api/bo/modifyClustersList', params).then((response) => response.data);
};
export const useMutationDeleteTaskFromCluster = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    taskIds: number[];
    clusterId: number;
    clusterType: string;
}
